import React, {PropsWithChildren} from "react";
import { classNames } from "../../shared/Utils";

interface IInputComponentProps {
    label?: string;
    name?: string;
    className?: string;
    placeholder?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputComponent: React.FC<IInputComponentProps> = ({label, className, placeholder, value, onChange }) => {
    return (
        <div>
            {label && <label className="block text-sm font-medium text-gray-700">{label}</label>}
            <input
                type="text"
                className={classNames(
                    "mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
                    className
                )}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
            />
        </div>
    );
}

export default InputComponent;
